export const ACTIVITY_MULTIPLIERS = {
  sedentary: 1.2,
  light: 1.375,
  moderate: 1.55,
  very_active: 1.725,
  athlete: 1.9,
};

export const GOAL_MODIFIERS = {
  cut_aggressive: -0.20,
  cut_moderate: -0.15,
  maintenance: 0,
  bulk_lean: 0.10,
  bulk_aggressive: 0.15,
};

export const MACRO_RATIOS = {
  cut: { proteinPerLb: 1.1, fatRatio: 0.25 },
  maintenance: { proteinPerLb: 0.9, fatRatio: 0.28 },
  bulk: { proteinPerLb: 0.85, fatRatio: 0.25 },
};

const lbsToKg = (lbs) => lbs * 0.453592;
const inchesToCm = (inches) => inches * 2.54;

export const calculateBMR = (data) => {
  let weightKg = data.unit === 'imperial' ? lbsToKg(data.weight) : parseFloat(data.weight);
  let heightCm = data.unit === 'imperial' ? inchesToCm(data.height) : parseFloat(data.height);
  let age = parseFloat(data.age);
  
  if (data.bodyFat && data.bodyFat > 0) {
    const leanMassKg = weightKg * (1 - (parseFloat(data.bodyFat) / 100));
    return Math.round(370 + (21.6 * leanMassKg));
  }
  
  let bmr = (10 * weightKg) + (6.25 * heightCm) - (5 * age);
  return Math.round(bmr + (data.gender === 'male' ? 5 : -161));
};

export const calculateMacros = (tdee, goalType, weightLbs) => {
  const config = goalType.includes('cut') ? MACRO_RATIOS.cut : 
                 goalType.includes('bulk') ? MACRO_RATIOS.bulk : 
                 MACRO_RATIOS.maintenance;

  const pGrams = Math.round(weightLbs * config.proteinPerLb);
  const fGrams = Math.round((tdee * config.fatRatio) / 9);
  const cGrams = Math.max(0, Math.round((tdee - (pGrams * 4 + fGrams * 9)) / 4));
  const total = (pGrams * 4) + (fGrams * 9) + (cGrams * 4);

  return {
    protein: { grams: pGrams, cal: pGrams * 4, pct: Math.round((pGrams * 4 / total) * 100) },
    fat: { grams: fGrams, cal: fGrams * 9, pct: Math.round((fGrams * 9 / total) * 100) },
    carbs: { grams: cGrams, cal: cGrams * 4, pct: Math.round((cGrams * 4 / total) * 100) },
    perMeal: {
      p: Math.round(pGrams / 4),
      f: Math.round(fGrams / 4),
      c: Math.round(cGrams / 4),
      cal: Math.round(total / 4)
    }
  };
};

export const generateProjections = (weightKg, tdee, dailyCalories) => {
  const diff = dailyCalories - tdee;
  const weeks = 12;
  const kgPerDay = diff / 7700;
  const data = [];

  let [best, real, plat] = [weightKg, weightKg, weightKg];

  for (let i = 0; i <= weeks; i++) {
    if (i > 0) {
      best += (kgPerDay * 7);
      real += (kgPerDay * 7 * Math.max(0.85, 1 - (i * 0.01)) * 0.9);
      plat += (kgPerDay * 7 * (i > 8 ? 0.2 : i > 4 ? 0.5 : 1));
    }
    data.push({
      week: i,
      Best: parseFloat(best.toFixed(1)),
      Realistic: parseFloat(real.toFixed(1)),
      Plateau: parseFloat(plat.toFixed(1)),
    });
  }
  return data;
};